import { memo } from 'react';
import { BodyText } from '../typography/Heading';
import styles from './description-wrapper.module.less';

const DescriptionWrapper = memo(({ className, ...props }) => (
    <BodyText className={[styles.descriptionWrapper, className].join(' ')} {...props} />
));

DescriptionWrapper.displayName = 'DescriptionWrapper';

export default DescriptionWrapper;
